var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/avatar.tsx";
import classNames from 'clsx';
import React from 'react';
import StillImage from 'soapbox/components/still-image';

/**
 * Legacy avatar component.
 * @see soapbox/components/ui/avatar/avatar.tsx
 * @deprecated
 */
const Avatar = _ref => {
  let {
    account,
    size,
    className
  } = _ref;
  if (!account) return null; // : TODO : remove inline and change all avatars to be sized using css

  const style = !size ? {} : {
    width: "".concat(size, "px"),
    height: "".concat(size, "px")
  };
  return /*#__PURE__*/React.createElement(StillImage, {
    className: classNames('rounded-full overflow-hidden', className),
    style: style,
    src: account.avatar,
    alt: "",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 5
    }
  });
};

export default Avatar;